import useTLO from "./useTLO"

export default function useComparableDeal(id) {
  return useTLO("sale", id)
}
